module.exports = __webpack_public_path__ + "img/bin-red.08bb597e.svg";